"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputList = props => {
  var _props$options;
  if ((props.value === "" || typeof props.value === "undefined") && props.defaultValue !== "" && typeof props.defaultValue !== "undefined") {
    props.value = props.defaultValue;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2", {
      "is-invalid": props.error
    })
  }, props.label), /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _classnames.default)(props.inputSizeClass, {
      "is-invalid": props.error
    }),
    list: "".concat(props.name, "List"),
    name: props.name,
    id: props.id ? props.id : props.name,
    value: props.value,
    placeholder: props.placeholder,
    onChange: e => props.onChange(e.target.value)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("datalist", {
    id: "".concat(props.name, "List")
  }, ((_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) > 0 && props.options.map((option, i) => {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: "option_".concat(i),
      value: option.id
    }, option.name);
  }))), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputList;
exports.default = _default;